import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const RoleGroupPermissionGate = (props: Omit<BasePermissionGateProps<"role">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="role"
		/>
	)
}

export default RoleGroupPermissionGate
